import styles from "./styles.module.scss";

const ASTERISK = "*";
const RequiredAsterisk = ({ className = "" }: { className?: string }) => (
  <span className={styles["required-asterisk"] + " " + className}>
    {" " + ASTERISK}
  </span>
);

export default RequiredAsterisk;
